import { FC, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormFields } from '../../types';
import { isFormSectionTitleConfig, schemaToFormConfig } from '../../utils';

import FormFieldRenderer from '../FormFieldRenderer';
import FormSectionTitleRenderer from '../FormSectionTitleRenderer';

import { Props } from './types';
import { prefixFormConfigNames } from './utils';

const SchemaRenderer: FC<Props> = ({
  schema,
  skipPropNames,
  namePrefix,
  resetOnMount = true,
}) => {
  const { reset } = useFormContext<FormFields>();

  const memoFormConfig = useMemo(() => {
    const baseFormConfig = schemaToFormConfig(schema, skipPropNames);
    return namePrefix
      ? prefixFormConfigNames(baseFormConfig, namePrefix)
      : baseFormConfig;
  }, [schema, skipPropNames, namePrefix]);

  useEffect(() => {
    if (resetOnMount) {
      reset();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  return (
    <>
      {memoFormConfig.map((fieldConfig) => {
        if (isFormSectionTitleConfig(fieldConfig)) {
          return (
            <FormSectionTitleRenderer
              key={fieldConfig.name}
              name={fieldConfig.name}
              type={fieldConfig.sectionTitleType}
            />
          );
        }

        return <FormFieldRenderer key={fieldConfig.name} field={fieldConfig} />;
      })}
    </>
  );
};

export default SchemaRenderer;
